import colors from "common/constants/colorsOld";
import type { DotsPerInch, PixelsPerInch } from "../types/nominalNumbersTypes";

export const PDF_DPI: DotsPerInch = 72 as DotsPerInch;
//styles
export const DEFAULT_FILL = colors.black;

export const SVG_PPI: PixelsPerInch = 96 as PixelsPerInch;

export const SVG_TO_PDF_SCALE = PDF_DPI / SVG_PPI; // Multiply SVG units with this value to get PDF points (dots)
export const PDF_TO_SVG_SCALE = SVG_PPI / PDF_DPI; // Multiply PDF points (dots) with this value to get SVG units
export const SVG_UNITS_PER_100TH_INCH = SVG_PPI * 0.01;
export const SVG_UNITS_TO_INCHES = 1 / SVG_PPI;

export const UNIT_TO_100TH_UNIT_SCALE = 100;

// Legacy font scaling: we keep this around to minimize diffs with baselines.
export const LEGACY_FONT_SCALE = SVG_PPI / PDF_DPI;

/**
 * @deprecated
 */
export const HUNDRETH_INCH_PER_SVG_UNIT = 1 / SVG_UNITS_PER_100TH_INCH;

export const PDF_FONT_TO_SVG_MULTIPLIER = 101.5 / 136;
export const PDF_FONT_TO_DXF_MULTIPLIER = 0.4; // dependent on the dxf-writer library
